import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';

import type { WatchlistItem } from '@/hooks/useWatchlist';
import type { Holding } from '@/hooks/portfolio/usePortfolio';

import { MonitoringPanelHeaderLink } from '../MonitoringPanelHeaderLink';

import { Header, CloseButton } from './styled';

interface Props {
  company: WatchlistItem['company'] | Holding['company'];
  onClose: () => void;
}

export const MonitoringPanelHeader = ({ company, onClose }: Props) => (
  <Header
    as="header"
    data-cy-id="monitoring-panel-header"
    templateColumns="auto 40px"
    alignItems="start"
  >
    <MonitoringPanelHeaderLink company={company} />
    <CloseButton onClick={onClose} aria-label="close">
      <CrossSolid />
    </CloseButton>
  </Header>
);
